export const API_VERSION = "v1";
export const AUTH_SERVICE_DOMAIN = "cms";
export const AUTH_SERVICE_PATH = "auth-service";
export const AGENT_SERVICE_PATH = "agent-service";
export const REPORT_SERVICE_PATH = "report-service";
export const WORKER_SERVICE_PATH = "worker-service";
export const SAAS_SERVICE_PATH = "saas-ticketing";
export const WALLET_SERVICE_PATH = "wallet-service";
export const GDS_SERVICE_PATH = "gds-service";
export const COMMERCE_SERVICE_PATH = "commerce";
export const CALL_CENTER_SERVICE_PATH = "call-center";
export const SAAS_CALL_CENTER_SERVICE_PATH = "saas-call-center";
export const AIRLINE_SERVICE_PATH = "airline-service";
export const OTP_SERVICE_PATH = "otp-service";
